import { useEvent } from "shared/lib/useEvent"
import { ProductPosition } from "shared/types/ProductPosition"

import { useCreateProductPosition } from "entities/product-positions/api/useCreateProductPosition"
import { useDeleteProductPosition } from "entities/product-positions/api/useDeleteProductPosition"
import { useUpdateProductPosition } from "entities/product-positions/api/useUpdateProductPosition"

export const FAVORITES_PROJECT_ID = "favorites"

export function useFavoriteMutations() {
  const [createFavorite] = useCreateProductPosition()
  const [updateFavorite] = useUpdateProductPosition()
  const [deleteFavorite] = useDeleteProductPosition()

  const handleSortProductPosition = useEvent(
    ({ id, position }: { id: string; position: number }) =>
      updateFavorite({
        displayPosition: position,
        productPosition: { id },
        projectID: FAVORITES_PROJECT_ID
      })
  )

  const handleUpdateFavorite = useEvent(
    ({
      id,
      favorite
    }: {
      id: string
      favorite: Partial<Omit<ProductPosition, "id" | "position">>
    }) =>
      updateFavorite({
        projectID: FAVORITES_PROJECT_ID,
        productPosition: { id, ...favorite }
      })
  )

  const handleDeleteFavorite = useEvent(({ id }: { id: string }) =>
    deleteFavorite(
      {
        id
      },
      FAVORITES_PROJECT_ID
    )
  )

  return {
    createFavorite,
    deleteFavorite: handleDeleteFavorite,
    updatePosition: handleSortProductPosition,
    updateFavorite: handleUpdateFavorite
  }
}
